import { FC } from 'react';
import ButtonGroup from 'components/Base/ButtonGroup/ButtonGroup';
import { Flex } from 'antd';
import { TimeOutline } from 'assets/icon/icon';
import { Text } from 'components/Base/Typography';
import { useEditEventTimezoneMutation } from 'redux/apiSlice/events.slice';
import {
  useShowToastNotification,
  ENotificationType,
} from 'components/Base/Notification';
import { TRtkErrorType } from 'data/types/generic.types';
import { useTranslation } from '@packages/utils';

interface TimezoneSelectorProps {
  eventId: string;
  timezone?: string;
  eventStatus?: string;
}

const TimezoneSelector: FC<TimezoneSelectorProps> = ({
  eventId,
  timezone,
  eventStatus,
}) => {
  const { t } = useTranslation();
  const { showToastNotification } = useShowToastNotification();
  const [editEventTimezone, { isLoading }] = useEditEventTimezoneMutation();

  const isDisabled =
    eventStatus === 'PUBLISHED' || eventStatus === 'CANCELLED' || isLoading;

  const timezoneOptions = [
    {
      label: 'MT',
      value: 'MT',
    },
    {
      label: 'PT',
      value: 'PT',
    },
  ];

  const handleTimezoneChange = async (value: string) => {
    try {
      await editEventTimezone({
        eventId,
        timezone: value,
      }).unwrap();

      showToastNotification({
        message: t('Timezone has been changed successfully.'),
        type: ENotificationType.SUCCESS,
      });
    } catch (error) {
      showToastNotification({
        message:
          (error as TRtkErrorType)?.data?.message ||
          'Failed to update timezone',
        type: ENotificationType.ERROR,
      });
    }
  };

  return (
    <Flex align="center" data-cy="timezone-selector" gap={8}>
      <Flex align="center" gap={8} style={{ width: 160 }}>
        <TimeOutline size={24} />
        <Text color="#808080">Timezone</Text>
      </Flex>
      <ButtonGroup
        options={timezoneOptions}
        value={timezone || 'MT'}
        size="small"
        disabled={isDisabled}
        onChange={handleTimezoneChange}
        style={{ width: '170px' }}
      />
    </Flex>
  );
};

export default TimezoneSelector;
